import { useDashboardQueries } from "@/hooks/useDashboardQueries";
import {
  SystemMetricsCard,
  RevenueChart,
  ResourceDistributionChart,
  RecentActivityFeed,
} from "@/components/dashboard";
import { AdminOrderStatsWidget } from "@/components/dashboard/AdminOrderStatsWidget";
import { LoadingSpinner, ErrorFallback } from "@/components/common";
import { PageHeader } from "@/components/common/page-header";
import { Users, Building2, Server, DollarSign } from "lucide-react";

export function DashboardPage() {
  const { systemMetrics, revenueMetrics, resourceMetrics, recentActivity } =
    useDashboardQueries();

  if (systemMetrics.isLoading) {
    return <LoadingSpinner />;
  }

  if (systemMetrics.error) {
    return <ErrorFallback error={systemMetrics.error as Error} />;
  }

  const metrics = systemMetrics.data!;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Dashboard"
        subtitle="Welcome to WiServices Admin Dashboard"
      />

      {/* System Metrics Cards */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <SystemMetricsCard
          title="Total Users"
          value={metrics.totalUsers}
          growth={metrics.userGrowth}
          icon={Users}
        />
        <SystemMetricsCard
          title="Total Tenants"
          value={metrics.totalTenants}
          growth={metrics.tenantGrowth}
          icon={Building2}
        />
        <SystemMetricsCard
          title="Active Resources"
          value={metrics.activeResources}
          growth={metrics.resourceGrowth}
          icon={Server}
        />
        <SystemMetricsCard
          title="Total Revenue"
          value={metrics.totalRevenue}
          growth={metrics.revenueGrowth}
          icon={DollarSign}
          format="currency"
        />
      </div>

      {/* Order Statistics Widget */}
      <AdminOrderStatsWidget />

      {/* Charts */}
      <div className="grid gap-4 md:grid-cols-3">
        {revenueMetrics.data && revenueMetrics.data.revenueByPeriod && (
          <RevenueChart data={revenueMetrics.data.revenueByPeriod} />
        )}
        {resourceMetrics.data && resourceMetrics.data.resourcesByType && (
          <ResourceDistributionChart
            data={resourceMetrics.data.resourcesByType}
          />
        )}
      </div>

      {/* Recent Activity */}
      {recentActivity.data && (
        <RecentActivityFeed activities={recentActivity.data} />
      )}
    </div>
  );
}
